import React from "react";
import { Dropdown, Menu, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useStoreState, useStoreActions } from "easy-peasy";
import { useHistory } from "react-router-dom";

export default function UserInfoBar({ ...props }) {
  const { user, refreshToken } = useStoreState((store) => store.auth);
  const { logout } = useStoreActions((store) => store.auth);
  let history = useHistory();

  const handleMenuClick = (e) => {
    switch (e.key) {
      case "profile":
        history.push("/panel/kullanici/profil");
        break;
      case "sign-out":
        logout({ refresh_token: refreshToken });
        break;
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="profile">
        <FontAwesomeIcon
          icon={["far", "id-badge"]}
          style={{ marginRight: 4 }}
        />
        Kullanıcı Profili
      </Menu.Item>
      <Menu.Item key="sign-out">
        <FontAwesomeIcon
          icon={["fas", "sign-out-alt"]}
          style={{ marginRight: 4 }}
        />
        Çıkış
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <Dropdown overlay={menu} placement="bottomRight" trigger="hover">
        <Button>
          <FontAwesomeIcon
            icon={["fas", "user-circle"]}
            style={{ marginRight: 4 }}
          />
          {user?.name || ""}
          <FontAwesomeIcon
            icon={["fas", "caret-down"]}
            style={{ marginLeft: 4 }}
          />
        </Button>
      </Dropdown>
    </div>
  );
}
